/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8 8V12.8C8 13.9201 8 14.4802 8.21799 14.908C8.40973 15.2843 8.71569 15.5903 9.09202 15.782C9.51984 16 10.0799 16 11.2 16H16M8 8V6M8 8H6M16 16V18M16 16H18M11 8H12.8C13.9201 8 14.4802 8 14.908 8.21799C15.2843 8.40973 15.5903 8.71569 15.782 9.09202C16 9.51984 16 10.0799 16 11.2V13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M16 16H11.2C10.0799 16 9.51984 16 9.09202 15.782C8.71569 15.5903 8.40973 15.2843 8.21799 14.908C8 14.4802 8 13.9201 8 12.8V8M16 16V18M16 16H18M8 8V6M8 8H6M11 8H12.8C13.9201 8 14.4802 8 14.908 8.21799C15.2843 8.40973 15.5903 8.71569 15.782 9.09202C16 9.51984 16 10.0799 16 11.2V13M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM8.75 6C8.75 5.58579 8.41421 5.25 8 5.25C7.58579 5.25 7.25 5.58579 7.25 6V7.25H6C5.58579 7.25 5.25 7.58579 5.25 8C5.25 8.41421 5.58579 8.75 6 8.75H7.25V12.8L7.25 12.8304V12.8305C7.24999 13.3646 7.24998 13.8104 7.27974 14.1747C7.31078 14.5546 7.37789 14.9112 7.54973 15.2485C7.81338 15.7659 8.23408 16.1866 8.75153 16.4503C9.08879 16.6221 9.44545 16.6892 9.82533 16.7203C10.1895 16.75 10.6354 16.75 11.1695 16.75H11.1695H11.2H15.25V18C15.25 18.4142 15.5858 18.75 16 18.75C16.4142 18.75 16.75 18.4142 16.75 18V16.75H18C18.4142 16.75 18.75 16.4142 18.75 16C18.75 15.5858 18.4142 15.25 18 15.25H16H11.2C10.6276 15.25 10.2434 15.2494 9.94748 15.2252C9.66035 15.2018 9.52307 15.1599 9.43251 15.1138C9.19731 14.9939 9.00608 14.8027 8.88624 14.5675C8.8401 14.4769 8.79822 14.3396 8.77476 14.0525C8.75058 13.7566 8.75 13.3724 8.75 12.8V8V6ZM12.8 8.75C13.3724 8.75 13.7566 8.75058 14.0525 8.77476C14.3396 8.79822 14.4769 8.8401 14.5675 8.88624C14.8027 9.00608 14.9939 9.19731 15.1138 9.43251C15.1599 9.52307 15.2018 9.66035 15.2252 9.94748C15.2494 10.2434 15.25 10.6276 15.25 11.2V13C15.25 13.4142 15.5858 13.75 16 13.75C16.4142 13.75 16.75 13.4142 16.75 13V11.2V11.1695V11.1695C16.75 10.6354 16.75 10.1896 16.7203 9.82533C16.6892 9.44545 16.6221 9.08879 16.4503 8.75153C16.1866 8.23408 15.7659 7.81338 15.2485 7.54973C14.9112 7.37789 14.5546 7.31078 14.1747 7.27974C13.8104 7.24998 13.3646 7.24999 12.8305 7.25H12.8304L12.8 7.25H11C10.5858 7.25 10.25 7.58579 10.25 8C10.25 8.41421 10.5858 8.75 11 8.75H12.8Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M16 16H11.2C10.0799 16 9.51984 16 9.09202 15.782C8.71569 15.5903 8.40973 15.2843 8.21799 14.908C8 14.4802 8 13.9201 8 12.8V8M16 16V18M16 16H18M8 8V6M8 8H6M11 8H12.8C13.9201 8 14.4802 8 14.908 8.21799C15.2843 8.40973 15.5903 8.71569 15.782 9.09202C16 9.51984 16 10.0799 16 11.2V13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M16 16H11.2C10.0799 16 9.51984 16 9.09202 15.782C8.71569 15.5903 8.40973 15.2843 8.21799 14.908C8 14.4802 8 13.9201 8 12.8V8M16 16V18M16 16H18M8 8V6M8 8H6M11 8H12.8C13.9201 8 14.4802 8 14.908 8.21799C15.2843 8.40973 15.5903 8.71569 15.782 9.09202C16 9.51984 16 10.0799 16 11.2V13M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 5.25C8.41421 5.25 8.75 5.58579 8.75 6V8V12.8C8.75 13.3724 8.75058 13.7566 8.77476 14.0525C8.79822 14.3396 8.8401 14.4769 8.88624 14.5675C9.00608 14.8027 9.19731 14.9939 9.43251 15.1138C9.52307 15.1599 9.66035 15.2018 9.94748 15.2252C10.2434 15.2494 10.6276 15.25 11.2 15.25H16H18C18.4142 15.25 18.75 15.5858 18.75 16C18.75 16.4142 18.4142 16.75 18 16.75H16.75V18C16.75 18.4142 16.4142 18.75 16 18.75C15.5858 18.75 15.25 18.4142 15.25 18V16.75H11.2H11.1695C10.6354 16.75 10.1896 16.75 9.82533 16.7203C9.44545 16.6892 9.08879 16.6221 8.75153 16.4503C8.23408 16.1866 7.81338 15.7659 7.54973 15.2485C7.37789 14.9112 7.31078 14.5546 7.27974 14.1747C7.24998 13.8104 7.24999 13.3646 7.25 12.8304L7.25 12.8V8.75H6C5.58579 8.75 5.25 8.41421 5.25 8C5.25 7.58579 5.58579 7.25 6 7.25H7.25V6C7.25 5.58579 7.58579 5.25 8 5.25ZM14.0525 8.77476C13.7566 8.75058 13.3724 8.75 12.8 8.75H11C10.5858 8.75 10.25 8.41421 10.25 8C10.25 7.58579 10.5858 7.25 11 7.25H12.8L12.8304 7.25C13.3646 7.24999 13.8104 7.24998 14.1747 7.27974C14.5546 7.31078 14.9112 7.37789 15.2485 7.54973C15.7659 7.81338 16.1866 8.23408 16.4503 8.75153C16.6221 9.08879 16.6892 9.44545 16.7203 9.82533C16.75 10.1896 16.75 10.6354 16.75 11.1695V11.2V13C16.75 13.4142 16.4142 13.75 16 13.75C15.5858 13.75 15.25 13.4142 15.25 13V11.2C15.25 10.6276 15.2494 10.2434 15.2252 9.94748C15.2018 9.66035 15.1599 9.52307 15.1138 9.43251C14.9939 9.19731 14.8027 9.00608 14.5675 8.88624C14.4769 8.8401 14.3396 8.79822 14.0525 8.77476Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
